export default [
    {
        name: '验证码登录'
    },
    {
        name: '密码登录'
    },
]
